import React from 'react';
import PrivacyPolicy from '../../../pages/PrivacyPolicy';
import TermsOfService from '../../../pages/TermsOfService';
import AccessibilityStatement from '../../../pages/AccessibilityStatement';

export const legalRoutes = [
  { path: '/privacy-policy', element: <PrivacyPolicy /> },
  { path: '/terms-of-service', element: <TermsOfService /> },
  { path: '/accessibility', element: <AccessibilityStatement /> }
];
